export const debounce = (cb, delay = 1000) => {
	let timer;

	return (...args) => {
		timer && clearTimeout(timer);

		timer = setTimeout(() => cb(...args), delay);
	}
}